<template>
  <SkeletonBlock
    :is-active="isSkeletonActive"
    :width="217"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useExcursionListingSkeleton } from '@/shared/composables/excursion/useExcursionDelayedListingSkeleton.ts';

  const { isSkeletonActive } = useExcursionListingSkeleton();
</script>

<style lang="scss"></style>
